import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../firebase";
import Loading from "../Loading/Loading";

export default function ProtectedRoute({ children }) {
  const [user, loading] = useAuthState(auth);

  // Firebase က login အခြေအနေကို စစ်နေတုန်း
  if (loading) {
    return <Loading />;
  }

  // Login မဝင်ရသေးရင် sign in စာမျက်နှာကိုပြန်လွှတ်မယ်
  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
}